module.exports = __webpack_public_path__ + "img/2-3.528765a9.jpg";